import React from "react";

export default class VirtualDiv extends React.Component {
  render() {
    return this.props.children;
  }
}
